import { render } from "./TopApp.vue?vue&type=template&id=7b3e9fd3&scoped=true"
import script from "./TopApp.vue?vue&type=script&lang=js"
export * from "./TopApp.vue?vue&type=script&lang=js"

import "./TopApp.vue?vue&type=style&index=0&id=7b3e9fd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3e9fd3"]])

export default __exports__